import React, { Component } from "react";
import "./Belgie.css";

import atvvannacht from "./assets/atv/atv-vannacht.png";
import tvlvannacht from "./assets/tvl/tvl-vannacht.png";
import tvovannacht from "./assets/tvo/tvo-vannacht.png";

class Belgie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      img: ""
    };
    this.myRef = React.createRef();
    this.myOverzicht = React.createRef();
    this.myVannacht = React.createRef();
    this.myDag = React.createRef();
  }

  componentDidMount() {
    // this.generateMap();
    // this.generateOverzicht();
    // this.generateVannacht();
  }

  componentDidUpdate(prevProps) {
    // if (this.props.data !== prevProps.data) {
    //   this.generateMap();
    //   this.generateOverzicht();
    //   this.generateVannacht();
    // }
  }

generate = async () => {
  await document.fonts.load('400 65px "Barlow"');
  await document.fonts.load('600 65px "Barlow"');
  await document.fonts.ready;

  this.generateMap();
  this.generateOverzicht();
  this.generateVannacht();
  this.generateDag();
};

  save = () => {
    var element = document.getElementById("weerpancarte");
    var link = document.createElement("a");
    link.download = "belgie.png";
    link.href = element.toDataURL();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    var element2 = document.getElementById("overzicht");
    var link2 = document.createElement("a");
    link2.download = "overzicht.png";
    link2.href = element2.toDataURL();
    document.body.appendChild(link2);
    link2.click();
    document.body.removeChild(link2);

    var element3 = document.getElementById("vannacht");
    var link3 = document.createElement("a");
    link3.download = "vannacht.png";
    link3.href = element3.toDataURL();
    document.body.appendChild(link3);
    link3.click();
    document.body.removeChild(link3);

    var element4 = document.getElementById("dag");
    var link4 = document.createElement("a");
    link4.download = "dag.png";
    link4.href = element4.toDataURL();
    document.body.appendChild(link4);
    link4.click();
    document.body.removeChild(link4);
  };

  generateMap = () => {
   var _this = this;
  var element = this.myRef.current;
  var c = document.createElement("canvas");
  c.setAttribute("id", "weerpancarte");
  var context = c.getContext("2d");

  c.width = 1920;
  c.height = 1080;

  var kaart = require("./assets/atv/belgie-" +
    _this.props.data.belgieTitle +
    ".png");

  if (this.props.channel === "tvl") {
    kaart = require("./assets/tvl/belgie-" +
      _this.props.data.belgieTitle +
      ".png");
  } else if (this.props.channel === "tvo") {
    kaart = require("./assets/tvo/belgie-" +
      _this.props.data.belgieTitle +
      ".png");
  }

  var base_image = new Image();
  base_image.src = kaart;

  base_image.onload = function() {
    context.drawImage(base_image, 0, 0);

    // Oostende
    _this.loadIcon(
      context,
      require("./assets/icons/" + _this.props.data.belgieIcon1.id + ".png"),
      810,
      198
    );
    _this.loadTemp(context, _this.props.data.belgieTemp1, 900, 354);

    // Antwerpen
    _this.loadIcon(
      context,
      require("./assets/icons/" + _this.props.data.belgieIcon2.id + ".png"),
      1208,
      180
    );
    _this.loadTemp(context, _this.props.data.belgieTemp2, 1299, 345);

    // Brussel
    _this.loadIcon(
      context,
      require("./assets/icons/" + _this.props.data.belgieIcon3.id + ".png"),
      1128,
      382
    );
    _this.loadTemp(context, _this.props.data.belgieTemp3, 1206, 544);

    // Hasselt
    _this.loadIcon(
      context,
      require("./assets/icons/" + _this.props.data.belgieIcon4.id + ".png"),
      1472,
      420
    );
    _this.loadTemp(context, _this.props.data.belgieTemp4, 1540, 585);

    // Mont Rigi
    _this.loadIcon(
      context,
      require("./assets/icons/" + _this.props.data.belgieIcon5.id + ".png"),
      1352,
      667
    );
    _this.loadTemp(context, _this.props.data.belgieTemp5, 1450, 825);

    // Wind Kust
    _this.loadTekst(context, _this.props.data.belgieWindText2, 663, 235, 30);
    _this.loadIconKust(
      context,
      require("./assets/icons/" + _this.props.data.belgieWind2 + ".png"),
      620,
      90
    );

    // Wind
    _this.loadTekst(context, _this.props.data.belgieWindText, 945, 790, 50);
    _this.loadIcon(
      context,
      require("./assets/icons/" + _this.props.data.belgieWind + ".png"),
      900,
      650
    );

    // Subtekst
    if (_this.props.data.belgieSub) {
      _this.loadSubTekst(context, _this.props.data.belgieSub, 115, 880, 40);
    }
  };

  element.replaceChildren(c);
};
  
  generateOverzicht = () => {
    var _this = this;
    var element = this.myOverzicht.current;
    var c = document.createElement("canvas");
    c.setAttribute("id", "overzicht");
    var context = c.getContext("2d");

    c.width = 1920;
    c.height = 1080;

    var kaart = require("./assets/atv/atv-" +
      _this.props.data.overzichtTitle1 +
      ".png");

    if (this.props.channel === "tvl") {
      kaart = require("./assets/tvl/tvl-" +
        _this.props.data.overzichtTitle1 +
        ".png");
    } else if (this.props.channel === "tvo") {
      kaart = require("./assets/tvo/tvo-" +
        _this.props.data.overzichtTitle1 +
        ".png");
    }

    var base_image = new Image();
    base_image.src = kaart;
    base_image.onload = function() {
      context.drawImage(base_image, 0, 0);

      // Dag1

      _this.loadIconMedium(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtIcon1.id +
          ".png"),
        325,
        250
      );
      _this.loadTempBold(context, _this.props.data.overzichtTempMax1, 385, 680, 120);
      _this.loadTemp(context, _this.props.data.overzichtTempMin1, 385, 558, 80);
      _this.loadIconWindOverzicht(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtWindIcon1 +
          ".png"),
        355,
        850
      );
      _this.loadTekst(
        context,
        _this.props.data.overzichtWindText1,
        385,
        980,
        30
      );
      // // Dag2
      _this.loadIconMedium(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtIcon2.id +
          ".png"),
        555,
        250
      );
      _this.loadTempBold(context, _this.props.data.overzichtTempMax2, 615, 680, 120);
      _this.loadTemp(context, _this.props.data.overzichtTempMin2, 615, 558, 80);
      _this.loadIconWindOverzicht(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtWindIcon2 +
          ".png"),
        585,
        850
      );
      _this.loadTekst(
        context,
        _this.props.data.overzichtWindText2,
        615,
        980,
        30
      );
      // // Dag3
      _this.loadIconMedium(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtIcon3.id +
          ".png"),
        780,
        250
      );
      _this.loadTempBold(context, _this.props.data.overzichtTempMax3, 844, 680, 120);
      _this.loadTemp(context, _this.props.data.overzichtTempMin3, 844, 558, 80);
      _this.loadIconWindOverzicht(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtWindIcon3 +
          ".png"),
        810,
        850
      );
      _this.loadTekst(
        context,
        _this.props.data.overzichtWindText3,
        844,
        980,
        30
      );
      // // Dag4
      _this.loadIconMedium(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtIcon4.id +
          ".png"),
        1010,
        250
      );
      _this.loadTempBold(
        context,
        _this.props.data.overzichtTempMax4,
        1075,
        680,
        120
      );
      _this.loadTemp(context, _this.props.data.overzichtTempMin4, 1075, 558, 80);
      _this.loadIconWindOverzicht(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtWindIcon4 +
          ".png"),
        1040,
        850
      );
      _this.loadTekst(
        context,
        _this.props.data.overzichtWindText4,
        1075,
        980,
        30
      );
      // // Dag5
      _this.loadIconMedium(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtIcon5.id +
          ".png"),
        1240,
        250
      );
      _this.loadTempBold(
        context,
        _this.props.data.overzichtTempMax5,
        1300,
        680,
        120
      );
      _this.loadTemp(context, _this.props.data.overzichtTempMin5, 1300, 558, 80);
      _this.loadIconWindOverzicht(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtWindIcon5 +
          ".png"),
        1270,
        850
      );
      _this.loadTekst(
        context,
        _this.props.data.overzichtWindText5,
        1300,
        980,
        30
      );
      // // Dag6
      _this.loadIconMedium(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtIcon6.id +
          ".png"),
        1470,
        250
      );
      _this.loadTempBold(
        context,
        _this.props.data.overzichtTempMax6,
        1534,
        680,
        120
      );
      _this.loadTemp(context, _this.props.data.overzichtTempMin6, 1534, 558, 80);
      _this.loadIconWindOverzicht(
        context,
        require("./assets/icons/" +
          _this.props.data.overzichtWindIcon6 +
          ".png"),
        1500,
        850
      );
      _this.loadTekst(
        context,
        _this.props.data.overzichtWindText6,
        1534,
        980,
        30
      );
    };

    element.replaceChildren(c);
  };

  generateVannacht = () => {
    var _this = this;
    var element = this.myVannacht.current;
    var c = document.createElement("canvas");
    c.setAttribute("id", "vannacht");
    var context = c.getContext("2d");

    c.width = 1920;
    c.height = 1080;

    var channel = this.props.channel;

    var kaart = atvvannacht;

    if (this.props.channel === "tvl") {
      kaart = tvlvannacht;
    } else if (this.props.channel === "tvo") {
      kaart = tvovannacht;
    }

    var base_image = new Image();
    base_image.src = kaart;
    base_image.onload = function() {
      context.drawImage(base_image, 0, 0);

      _this.loadIconLarge(
        context,
        require("./assets/icons/" + _this.props.data.vannachtIcon.id + "N.png"),
        970,
        390
      );
      if (channel === "tvl") {
        _this.loadTemp(context, _this.props.data.vannachtTemp, 1145, 620, 85);
      } else if (channel === "tvo") {
        _this.loadTemp(context, _this.props.data.vannachtTemp, 1230, 620, 85);
      } else if (channel === "atv") {
        _this.loadTemp(context, _this.props.data.vannachtTemp, 1230, 620, 85);
      }

      _this.loadIcon(
        context,
        require("./assets/icons/" + _this.props.data.vannachtWind + ".png"),
        300,
        700
      );
      _this.loadTekst(context, _this.props.data.vannachtWindText, 350, 850, 50);

      if (_this.props.data.vannachtSub) {
        _this.loadSubTekst(context, _this.props.data.vannachtSub, 350, 610, 40);
      }
    };

    element.replaceChildren(c);
  };

  generateDag = () => {
    var _this = this;
    var element = this.myDag.current;
    var c = document.createElement("canvas");
    c.setAttribute("id", "dag");
    var context = c.getContext("2d");

    c.width = 1920;
    c.height = 1080;

    var channel = this.props.channel;

    var kaart = require("./assets/atv/atv-" +
      _this.props.data.provincieTitle +
      ".png");

    if (this.props.channel === "tvl") {
      kaart = require("./assets/tvl/tvl-" +
        _this.props.data.provincieTitle +
        ".png");
    } else if (this.props.channel === "tvo") {
      kaart = require("./assets/tvo/tvo-" +
        _this.props.data.provincieTitle +
        ".png");
    }

    var base_image = new Image();
    base_image.src = kaart;
    base_image.onload = function() {
      context.drawImage(base_image, 0, 0);

      _this.loadIconLarge(
        context,
        require("./assets/icons/" + _this.props.data.provincieIcon.id + ".png"),
        970,
        390
      );
      if (channel === "tvl") {
        _this.loadTemp(context, _this.props.data.provincieTemp, 1145, 620, 85);
      } else if (channel === "tvo") {
        _this.loadTemp(context, _this.props.data.provincieTemp, 1220, 615, 85);
      } else if (channel === "atv") {
        _this.loadTemp(context, _this.props.data.provincieTemp, 1230, 620, 85);
      }

      _this.loadIcon(
        context,
        require("./assets/icons/" + _this.props.data.provincieWind + ".png"),
        300,
        700
      );
      _this.loadTekst(
        context,
        _this.props.data.provincieWindText,
        350, 850, 50
      );
      if (_this.props.data.provincieSub) {
        _this.loadSubTekst(
          context,
          _this.props.data.provincieSub,
          350, 610, 40
        );
      }
    };

    element.replaceChildren(c);
  };

  loadIcon = (context, icon, x, y) => {
    var drawing = new Image();
    drawing.src = icon;
    drawing.onload = function() {
      context.drawImage(drawing, x, y, 100, 100);
    };
  };

  loadIconKust = (context, icon, x, y) => {
    var drawing = new Image();
    drawing.src = icon;
    drawing.onload = function() {
      context.drawImage(drawing, x, y, 100, 100);
    };
  };

  loadIconWindOverzicht = (context, icon, x, y) => {
    var drawing = new Image();
    drawing.src = icon;
    drawing.onload = function() {
      context.drawImage(drawing, x, y, 80, 80);
    };
  };

  loadIconLarge = (context, icon, x, y) => {
    var drawing = new Image();
    drawing.src = icon;
    drawing.onload = function() {
      context.drawImage(drawing, x, y, 200, 200);
    };
  };
  loadIconMedium = (context, icon, x, y) => {
    var drawing = new Image();
    drawing.src = icon;
    drawing.onload = function() {
      context.drawImage(drawing, x, y, 150, 150);
    };
  };

  loadTemp = (context, temp, x, y, size = 68) => {
    context.font = `400 ${size}px "Barlow"`;
    context.fillStyle = "white";
    context.textAlign = "center";
    context.fillText(temp, x, y);
  };
  loadTempBold = (context, temp, x, y, size = 68) => {
    context.font = `600 ${size}px "Barlow"`;
    context.fillStyle = "white";
    context.textAlign = "center";
    context.fillText(temp, x, y);
  };

  loadTekst = (context, temp, x, y, size) => {
    context.font = `42px "Barlow"`;
    context.fillStyle = "white";
    context.textAlign = "center";
    context.fillText(temp, x, y);
  };

  loadSubTekst = (context, temp, x, y, size) => {
    context.font = `42px "Barlow"`;
    context.fillStyle = "white";
    context.textAlign = "center";
    context.fillText(temp, x, y);
  };

  render() {
    return (
      <div>
        <button onClick={this.generate}>generate</button>
        <button onClick={this.save}>save</button>

        <div className="pancarteContainer">
          <div ref={this.myVannacht}></div>
        </div>
        <div className="pancarteContainer">
          <div ref={this.myDag}></div>
        </div>
        <div className="pancarteContainer">
          <div ref={this.myRef}></div>
        </div>
        <div className="pancarteContainer">
          <div ref={this.myOverzicht}></div>
        </div>
      </div>
    );
  }
}

export default Belgie;
